import {
  ApplicationCreationTypeEnum as ApplicationCreationTypeEnumPrisma,
  ApplicationStatusEnum as ApplicationStatusEnumPrisma,
  ApplicationTypeEnum as ApplicationTypeEnumPrisma,
  ApprovalStatusEnum as ApprovalStatusEnumPrisma,
  ApprovalWorkflowScopeEnum as ApprovalWorkflowScopeEnumPrisma,
  CalendarProviderEnum as CalendarProviderEnumPrisma,
  CandidateApplicationDuplicationStatusEnum as CandidateApplicationDuplicationStatusEnumPrisma,
  CandidateInterviewStatusEnum as CandidateInterviewStatusEnumPrisma,
  CanStartNewJobEnum as CanStartNewJobEnumPrisma,
  ClosedReasonEnum as ClosedReasonEnumPrisma,
  CompanyDepartmentTypeEnum as CompanyDepartmentTypeEnumPrisma,
  CompanySavedViewLayoutEnum as CompanySavedViewLayoutEnumPrisma,
  CompanySavedViewLocationEnum as CompanySavedViewLocationEnumPrisma,
  CompanySavedViewTypeEnum as CompanySavedViewTypeEnumPrisma,
  CompanySavedViewVisibilityEnum as CompanySavedViewVisibilityEnumPrisma,
  CompanyUserStatusEnum as CompanyUserStatusEnumPrisma,
  ConditionTypeEnum as ConditionTypeEnumPrisma,
  ConnectedEmailProviderEnum as ConnectedEmailProviderEnumPrisma,
  CoreReportNameEnum as CoreReportNameEnumPrisma,
  CurrentStageEnum as CurrentStageEnumPrisma,
  CustomCandidateFieldTypeEnum as CustomCandidateFieldTypeEnumPrisma,
  CustomFieldInputTypeEnum as CustomFieldInputTypeEnumPrisma,
  DatePostedEnum as DatePostedEnumPrisma,
  DefaultTokenTypeEnum as DefaultTokenTypeEnumPrisma,
  DocumentTypeEnum as DocumentTypeEnumPrisma,
  EducationLevelEnum as EducationLevelEnumPrisma,
  EducationLevelPrefEnum as EducationLevelPrefEnumPrisma,
  EmployeeCountEnum as EmployeeCountEnumPrisma,
  EnrichedEmailTypeEnum as EnrichedEmailTypeEnumPrisma,
  EnrichedPhoneNumberTypeEnum as EnrichedPhoneNumberTypeEnumPrisma,
  EventTypeEnum as EventTypeEnumPrisma,
  GenderEnum as GenderEnumPrisma,
  IndustryEnum as IndustryEnumPrisma,
  InterviewLengthEnum as InterviewLengthEnumPrisma,
  InterviewSchedulingEnum as InterviewSchedulingEnumPrisma,
  InvitationStatusEnum as InvitationStatusEnumPrisma,
  InviteStatusEnum as InviteStatusEnumPrisma,
  JobActionEnum as JobActionEnumPrisma,
  JobLevelEnum as JobLevelEnumPrisma,
  JobStatusEnum as JobStatusEnumPrisma,
  JobTypeEnum as JobTypeEnumPrisma,
  JobTypePrefEnum as JobTypePrefEnumPrisma,
  MessageOwnerEnum as MessageOwnerEnumPrisma,
  MessageTypeEnum as MessageTypeEnumPrisma,
  NameEnum as NameEnumPrisma,
  NylasEventStatusEnum as NylasEventStatusEnumPrisma,
  OfferDocumentTemplateStatusEnum as OfferDocumentTemplateStatusEnumPrisma,
  OfferDocumentTemplateTypeEnum as OfferDocumentTemplateTypeEnumPrisma,
  OfferFileTypeEnum as OfferFileTypeEnumPrisma,
  OfferStatusEnum as OfferStatusEnumPrisma,
  OpeningStatusEnum as OpeningStatusEnumPrisma,
  OpeningTypeEnum as OpeningTypeEnumPrisma,
  OverallRecommendationEnum as OverallRecommendationEnumPrisma,
  PayTypeEnum as PayTypeEnumPrisma,
  PermissionEnum as PermissionEnumPrisma,
  PositionsToFillEnum as PositionsToFillEnumPrisma,
  PreferredAnswerTypeEnum as PreferredAnswerTypeEnumPrisma,
  QuestionTypeEnum as QuestionTypeEnumPrisma,
  RejectionReasonEnum as RejectionReasonEnumPrisma,
  RelocationTypePreferenceEnum as RelocationTypePreferenceEnumPrisma,
  RepeatsEnum as RepeatsEnumPrisma,
  RepeatType as RepeatTypePrisma,
  ReportSchedulerType as ReportSchedulerTypeEnumPrisma,
  RoleEnum as RoleEnumPrisma,
  RoleTypeEnum as RoleTypeEnumPrisma,
  ScorecardQuestionTypeEnum as ScorecardQuestionTypeEnumPrisma,
  ScorecardStatusEnum as ScorecardStatusEnumPrisma,
  SectionTypeEnum as SectionTypeEnumPrisma,
  SelectionDisplayEnum as SelectionDisplayEnumPrisma,
  SequenceCandidateStatusEnum as SequenceCandidateStatusEnumPrisma,
  SequenceStatusEnum as SequenceStatusEnumPrisma,
  SequenceStepSchedulerTypeEnum as SequenceStepSchedulerTypeEnumPrisma,
  SequenceStepSendTimeTypeEnum as SequenceStepSendTimeTypeEnumPrisma,
  SequenceStepSpreadStrategyEnum as SequenceStepSpreadStrategyEnumPrisma,
  SequenceVisibilityEnum as SequenceVisibilityEnumPrisma,
  SourceCategoryEnum as SourceCategoryEnumPrisma,
  StageEnum as StageEnumPrisma,
  SubIndustryEnum as SubIndustryTypeEnumPrisma,
  TalentPoolTypeEnum as TalentPoolTypeEnumPrisma,
  TalentPoolVisibilityEnum as TalentPoolVisibilityEnumPrisma,
  TeamSizeEnum as TeamSizeEnumPrisma,
  TemplateStageVisibilityEnum as TemplateStageVisibilityEnumPrisma,
  TokenCategoryNameEnum as TokenCategoryNameEnumPrisma,
  TokenNameEnum as TokenNameEnumPrisma,
  TokenStatusEnum as TokenStatusEnumPrisma,
  TravelTypeEnum as TravelTypeEnumPrisma,
  UploadedCandidateTypeEnum as UploadedCandidateTypeEnumPrisma,
  UserActionEnum as UserActionEnumPrisma,
  VeteranStatusEnum as VeteranStatusEnumPrisma,
  WebsiteTypeEnum as WebsiteTypeEnumPrisma,
  WillingToRelocateEnum as WillingToRelocateEnumPrisma,
  WorkPlaceCandidateEnum as WorkPlaceCandidateEnumPrisma,
  WorkplaceTypeEnum as WorkplaceTypeEnumPrisma,
  YearsOfExperienceEnum as YearsOfExperienceEnumPrisma,
  IconTypeEnum as IconTypeEnumPrisma,
} from 'scalis-db-v2'
import { JobLevelRole, OrganizationRole, RaceEthnicity } from '~/v2/enums'
import { schemaBuilder } from '../schema-builder/builder'

export const MessageTypeEnum = schemaBuilder.enumType('MessageTypeEnum', {
  values: Object.values(MessageTypeEnumPrisma) as [string, ...string[]],
})

export const MessageOwnerEnum = schemaBuilder.enumType('MessageOwnerEnum', {
  values: Object.values(MessageOwnerEnumPrisma) as [string, ...string[]],
})

export const ApplicationTypeEnum = schemaBuilder.enumType('ApplicationTypeEnum', {
  values: Object.values(ApplicationTypeEnumPrisma) as [string, ...string[]],
})

export const ApprovalWorkflowScopeEnum = schemaBuilder.enumType('ApprovalWorkflowScopeEnum', {
  values: Object.values(ApprovalWorkflowScopeEnumPrisma) as [string, ...string[]],
})

export const ApplicationStatusEnum = schemaBuilder.enumType('ApplicationStatusEnum', {
  values: Object.values(ApplicationStatusEnumPrisma) as [string, ...string[]],
})

export const InviteStatusEnum = schemaBuilder.enumType('InviteStatusEnum', {
  values: Object.values(InviteStatusEnumPrisma) as [string, ...string[]],
})

export const NylasEventStatusEnum = schemaBuilder.enumType('NylasEventStatusesEnum', {
  values: Object.values(NylasEventStatusEnumPrisma) as [string, ...string[]],
})

export const RepeatsEnum = schemaBuilder.enumType('RepeatsEnum', {
  values: Object.values(RepeatsEnumPrisma),
})

export const EventTypeEnum = schemaBuilder.enumType('EventTypeEnum', {
  values: Object.values(EventTypeEnumPrisma),
})

export const RoleEnum = schemaBuilder.enumType('RoleEnum', {
  values: Object.values(RoleEnumPrisma) as [string, ...string[]],
})

export const OrganizationRoleEnum = schemaBuilder.enumType('OrganizationRoleEnum', {
  values: Object.values(OrganizationRole),
})

export const JobLevelRoleEnum = schemaBuilder.enumType('JobLevelRoleEnum', {
  values: Object.values(JobLevelRole) as [string, ...string[]],
})

export const JobTypeEnum = schemaBuilder.enumType('JobTypeEnum', {
  values: Object.values(JobTypeEnumPrisma),
})

export const JobLevelEnum = schemaBuilder.enumType('JobLevelEnum', {
  values: Object.values(JobLevelEnumPrisma) as [string, ...string[]],
})

export const WorkplaceTypeEnum = schemaBuilder.enumType('WorkplaceTypeEnum', {
  values: Object.values(WorkplaceTypeEnumPrisma) as [string, ...string[]],
})

export const JobTypePrefEnum = schemaBuilder.enumType('JobTypePrefEnum', {
  values: Object.values(JobTypePrefEnumPrisma) as [string, ...string[]],
})

export const CanStartNewJobEnum = schemaBuilder.enumType('CanStartNewJobEnum', {
  values: Object.values(CanStartNewJobEnumPrisma) as [string, ...string[]],
})

export const GenderEnum = schemaBuilder.enumType('GenderEnum', {
  values: Object.values(GenderEnumPrisma),
})

export const InterviewSchedulingEnum = schemaBuilder.enumType('InterviewSchedulingEnum', {
  values: Object.values(InterviewSchedulingEnumPrisma) as [string, ...string[]],
})

export const ApplicationCreationTypeEnum = schemaBuilder.enumType('ApplicationCreationTypeEnum', {
  values: Object.values(ApplicationCreationTypeEnumPrisma) as [string, ...string[]],
})

export const CurrentStageEnum = schemaBuilder.enumType('CurrentStageEnum', {
  values: Object.values(CurrentStageEnumPrisma) as [string, ...string[]],
})

export const ApprovalStatusEnum = schemaBuilder.enumType('ApprovalStatusEnum', {
  values: Object.values(ApprovalStatusEnumPrisma) as [string, ...string[]],
})

export const EducationLevelPrefEnum = schemaBuilder.enumType('EducationLevelPrefEnum', {
  values: Object.values(EducationLevelPrefEnumPrisma) as [string, ...string[]],
})

export const EmployeeCountEnum = schemaBuilder.enumType('EmployeeCountEnum', {
  values: Object.values(EmployeeCountEnumPrisma) as [string, ...string[]],
})

export const NameEnum = schemaBuilder.enumType('NameEnum', {
  values: Object.values(NameEnumPrisma) as [string, ...string[]],
})

export const PositionsToFillEnum = schemaBuilder.enumType('PositionsToFillEnum', {
  values: Object.values(PositionsToFillEnumPrisma) as [string, ...string[]],
})

export const SourceCategoryEnum = schemaBuilder.enumType('SourceCategoryEnum', {
  values: Object.values(SourceCategoryEnumPrisma) as [string, ...string[]],
})

export const StageEnum = schemaBuilder.enumType('StageEnum', {
  values: Object.values(StageEnumPrisma) as [string, ...string[]],
})

export const TeamSizeEnum = schemaBuilder.enumType('TeamSizeEnum', {
  values: Object.values(TeamSizeEnumPrisma) as [string, ...string[]],
})

export const TravelTypeEnum = schemaBuilder.enumType('TravelTypeEnum', {
  values: Object.values(TravelTypeEnumPrisma) as [string, ...string[]],
})

export const PayTypeEnum = schemaBuilder.enumType('PayTypeEnum', {
  values: Object.values(PayTypeEnumPrisma),
})

export const VeteranStatusEnum = schemaBuilder.enumType('VeteranStatusEnum', {
  values: Object.values(VeteranStatusEnumPrisma),
})

export const InvitationStatusEnum = schemaBuilder.enumType('InvitationStatusEnum', {
  values: Object.values(InvitationStatusEnumPrisma) as [string, ...string[]],
})

export const RoleTypeEnum = schemaBuilder.enumType('RoleTypeEnum', {
  values: Object.values(RoleTypeEnumPrisma) as [string, ...string[]],
})

export const RaceEthnicityEnum = schemaBuilder.enumType('RaceEthnicityEnum', {
  values: Object.values(RaceEthnicity),
})

export const CalendarProviderEnum = schemaBuilder.enumType('CalendarProviderEnum', {
  values: Object.values(CalendarProviderEnumPrisma),
})

export const CandidateApplicationDuplicationStatusEnum = schemaBuilder.enumType(
  'CandidateApplicationDuplicationStatusEnum',
  {
    values: Object.values(CandidateApplicationDuplicationStatusEnumPrisma) as [string, ...string[]],
  },
)

export const CompanyUserStatusEnum = schemaBuilder.enumType('CompanyUserStatusEnum', {
  values: Object.values(CompanyUserStatusEnumPrisma) as [string, ...string[]],
})

export const SortDirectionEnum = schemaBuilder.enumType('SortDirection', {
  values: ['asc', 'desc'],
})

export const InterviewScheduleEnum = schemaBuilder.enumType('InterviewScheduleEnum', {
  values: ['LATER', 'SCHEDULER'],
})

export enum ReminderMethod {
  POPUP = 'popup',
  EMAIL = 'email',
  DISPLAY = 'display',
  SOUND = 'sound',
}

export const ReminderMethodEnum = schemaBuilder.enumType('ReminderMethodEnum', {
  values: Object.values(ReminderMethod),
})

export enum CandidateType {
  GUEST = 'GUEST',
  JOBSEEKER = 'JOBSEEKER',
  UPLOADED_CANDIDATE = 'UPLOADED_CANDIDATE',
}

export const CandidateTypeEnum = schemaBuilder.enumType('CandidateTypeEnum', {
  values: Object.values(CandidateType),
})

export enum NylasEventParticipantStatus {
  noreply = 'noreply',
  accepted = 'accepted',
  tentative = 'tentative',
  declined = 'declined',
}

export enum NylasWebhookTypes {
  'CALENDAR_CREATED' = 'calendar.created',
  'CALENDAR_UPDATED' = 'calendar.updated',
  'CALENDAR_DELETED' = 'calendar.deleted',
  'EVENT_CREATED' = 'event.created',
  'EVENT_UPDATED' = 'event.updated',
  'EVENT_DELETED' = 'event.deleted',
  'MESSAGE_OPENED' = 'message.opened',
  'THREAD_REPLIED' = 'thread.replied',
  'MESSAGE_CLICKED' = 'message.link_clicked',
  'SCHEDULER_BOOKING_CREATED' = 'booking.created',
}

export const EducationLevelEnum = schemaBuilder.enumType('EducationLevelEnum', {
  values: Object.values(EducationLevelEnumPrisma) as [string, ...string[]],
})

export const WorkPlaceCandidateEnum = schemaBuilder.enumType('WorkPlaceCandidateEnum', {
  values: Object.values(WorkPlaceCandidateEnumPrisma) as [string, ...string[]],
})

export const IndustryEnum = schemaBuilder.enumType('IndustryEnum', {
  values: Object.values(IndustryEnumPrisma) as [string, ...string[]],
})

export const TemplateStageVisibilityEnum = schemaBuilder.enumType('TemplateStageVisibilityEnum', {
  values: Object.values(TemplateStageVisibilityEnumPrisma) as [string, ...string[]],
})

export const JobStatusEnum = schemaBuilder.enumType('JobStatusEnum', {
  values: Object.values(JobStatusEnumPrisma) as [string, ...string[]],
})

export const YearsOfExperienceEnum = schemaBuilder.enumType('YearsOfExperienceEnum', {
  values: Object.values(YearsOfExperienceEnumPrisma) as [string, ...string[]],
})

export const OpeningStatusEnum = schemaBuilder.enumType('OpeningStatusEnum', {
  values: Object.values(OpeningStatusEnumPrisma) as [string, ...string[]],
})

export const OpeningTypeEnum = schemaBuilder.enumType('OpeningTypeEnum', {
  values: Object.values(OpeningTypeEnumPrisma),
})

export const ClosedReasonEnum = schemaBuilder.enumType('ClosedReasonEnum', {
  values: Object.values(ClosedReasonEnumPrisma) as [string, ...string[]],
})

export const QuestionTypeEnum = schemaBuilder.enumType('QuestionTypeEnum', {
  values: Object.values(QuestionTypeEnumPrisma) as [string, ...string[]],
})

export const PermissionEnum = schemaBuilder.enumType('PermissionEnum', {
  values: Object.values(PermissionEnumPrisma) as [string, ...string[]],
})

export const RejectionReasonEnum = schemaBuilder.enumType('RejectionReasonEnum', {
  values: Object.values(RejectionReasonEnumPrisma) as [string, ...string[]],
})

export const WillingToRelocateEnum = schemaBuilder.enumType('WillingToRelocateEnum', {
  values: Object.values(WillingToRelocateEnumPrisma) as [string, ...string[]],
})

export const InterviewLengthEnum = schemaBuilder.enumType('InterviewLengthEnum', {
  values: Object.values(InterviewLengthEnumPrisma) as [string, ...string[]],
})

export const WebsiteTypeEnum = schemaBuilder.enumType('WebsiteTypeEnum', {
  values: Object.values(WebsiteTypeEnumPrisma),
})

export const ScorecardQuestionTypeEnum = schemaBuilder.enumType('ScorecardQuestionTypeEnum', {
  values: Object.values(ScorecardQuestionTypeEnumPrisma),
})

export const SectionTypeEnum = schemaBuilder.enumType('SectionTypeEnum', {
  values: Object.values(SectionTypeEnumPrisma),
})

export const SubIndustryTypeEnum = schemaBuilder.enumType('SubIndustryTypeEnum', {
  values: Object.values(SubIndustryTypeEnumPrisma),
})

export const ScorecardStatusTypeEnum = schemaBuilder.enumType('ScorecardStatusTypeEnum', {
  values: Object.values(ScorecardStatusEnumPrisma),
})

export const OverallRecommendationEnum = schemaBuilder.enumType('OverallRecommendationEnum', {
  values: Object.values(OverallRecommendationEnumPrisma),
})

export const CompanyDepartmentTypeEnum = schemaBuilder.enumType('CompanyDepartmentTypeEnum', {
  values: Object.values(CompanyDepartmentTypeEnumPrisma) as [string, ...string[]],
})

export const UserActionEnum = schemaBuilder.enumType('UserActionEnum', {
  values: Object.values(UserActionEnumPrisma),
})

export const JobActionEnum = schemaBuilder.enumType('JobActionEnum', {
  values: Object.values(JobActionEnumPrisma),
})

export const CandidateInterviewStatusEnum = schemaBuilder.enumType('CandidateInterviewStatusEnum', {
  values: Object.values(CandidateInterviewStatusEnumPrisma),
})

export const OfferStatusEnum = schemaBuilder.enumType('OfferStatusEnum', {
  values: Object.values(OfferStatusEnumPrisma),
})

export const OfferFileTypeEnum = schemaBuilder.enumType('OfferFileTypeEnum', {
  values: Object.values(OfferFileTypeEnumPrisma),
})

export const DefaultTokenTypeEnum = schemaBuilder.enumType('DefaultTokenTypeEnum', {
  values: Object.values(DefaultTokenTypeEnumPrisma),
})

export const DocumentTypeEnum = schemaBuilder.enumType('DocumentTypeEnum', {
  values: Object.values(DocumentTypeEnumPrisma),
})

export const TokenNameEnum = schemaBuilder.enumType('TokenNameEnum', {
  values: Object.values(TokenNameEnumPrisma),
})

export const OfferDocumentTemplateTypeEnum = schemaBuilder.enumType('OfferDocumentTemplateTypeEnum', {
  values: Object.values(OfferDocumentTemplateTypeEnumPrisma),
})

export const OfferDocumentTemplateStatusEnum = schemaBuilder.enumType('OfferDocumentTemplateStatusEnum', {
  values: Object.values(OfferDocumentTemplateStatusEnumPrisma),
})

export const TokenCategoryNameEnum = schemaBuilder.enumType('TokenCategoryNameEnum', {
  values: Object.values(TokenCategoryNameEnumPrisma),
})

export const ConditionTypeEnum = schemaBuilder.enumType('ConditionTypeEnum', {
  values: Object.values(ConditionTypeEnumPrisma),
})

export const TokenStatusEnum = schemaBuilder.enumType('TokenStatusEnum', {
  values: Object.values(TokenStatusEnumPrisma),
})

export const CustomFieldInputTypeEnum = schemaBuilder.enumType('CustomFieldInputTypeEnum', {
  values: Object.values(CustomFieldInputTypeEnumPrisma),
})
export const ProfileTypeEnum = schemaBuilder.enumType('ProfileTypeEnum', {
  values: ['UPLOADED_CANDIDATE', 'JOB_SEEKER'],
})

export const ReportSchedulerTypeEnum = schemaBuilder.enumType('ReportSchedulerTypeEnum', {
  values: Object.values(ReportSchedulerTypeEnumPrisma) as [string, ...string[]],
})

export const CoreReportNameEnum = schemaBuilder.enumType('CoreReportNameEnum', {
  values: Object.values(CoreReportNameEnumPrisma),
})

export enum RepeatDaysOfWeek {
  SUN = 'SUN',
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
}

export const RepeatTypeEnum = schemaBuilder.enumType('RepeatTypeEnum', {
  values: Object.values(RepeatTypePrisma),
})

export const RepeatDaysOfWeekEnum = schemaBuilder.enumType('RepeatDaysOfWeekEnum', {
  values: Object.values(RepeatDaysOfWeek),
})

export enum ReportFilterTab {
  DEFAULT = 'DEFAULT',
  SHARED = 'SHARED',
  FAVORITE = 'FAVORITE',
  SCHEDULED = 'SCHEDULED',
}

export const ReportFilterTabEnum = schemaBuilder.enumType('ReportFilterTabEnum', {
  values: Object.values(ReportFilterTab),
})

export enum CoreReportFilterType {
  TEXT = 'TEXT',
  DATE = 'DATE',
}

export const CoreReportFilterTypeEnum = schemaBuilder.enumType('CoreReportFilterTypeEnum', {
  values: Object.values(CoreReportFilterType),
})

export const UploadedCandidateTypeEnum = schemaBuilder.enumType('UploadedCandidateTypeEnum', {
  values: Object.values(UploadedCandidateTypeEnumPrisma),
})

export enum FilterContentType {
  CANDIDATE_NAMES = 'candidateNames',
  EMAILS = 'emails',
  SKILLS = 'skills',
  DEGREES = 'degrees',
  COMPANIES = 'companies',
  JOB_TITLES = 'jobTitles',
  SCHOOLS = 'schools',
  MAJORS = 'majors',
  CREDITED_COMPANY_USER = 'creditedCompanyUser',
  LABELS = 'labels',
  PROSPECT_STATUS = 'prospectStatus',
  PROSPECT_OWNER = 'prospectOwner',
}

export const FilterContentTypeEnum = schemaBuilder.enumType('FilterContentTypeEnum', {
  values: Object.values(FilterContentType),
})

export const PreferredAnswerTypeEnum = schemaBuilder.enumType('PreferredAnswerTypeEnum', {
  values: Object.values(PreferredAnswerTypeEnumPrisma),
})

export const SelectionDisplayEnum = schemaBuilder.enumType('SelectionDisplayEnum', {
  values: Object.values(SelectionDisplayEnumPrisma),
})

export const ConnectedEmailProviderEnum = schemaBuilder.enumType('ConnectedEmailProviderEnum', {
  values: Object.values(ConnectedEmailProviderEnumPrisma),
})

export const EnrichedEmailTypeEnum = schemaBuilder.enumType('EnrichedEmailTypeEnum', {
  values: Object.values(EnrichedEmailTypeEnumPrisma),
})

export const EnrichedPhoneNumberTypeEnum = schemaBuilder.enumType('EnrichedPhoneNumberTypeEnum', {
  values: Object.values(EnrichedPhoneNumberTypeEnumPrisma),
})

export const CompanySavedViewLayoutEnum = schemaBuilder.enumType('CompanySavedViewLayoutEnum', {
  values: Object.values(CompanySavedViewLayoutEnumPrisma),
})

export const CompanySavedViewLocationEnum = schemaBuilder.enumType('CompanySavedViewLocationEnum', {
  values: Object.values(CompanySavedViewLocationEnumPrisma),
})

export const CompanySavedViewTypeEnum = schemaBuilder.enumType('CompanySavedViewTypeEnum', {
  values: Object.values(CompanySavedViewTypeEnumPrisma),
})

export const CompanySavedViewVisibilityEnum = schemaBuilder.enumType('CompanySavedViewVisibilityEnum', {
  values: Object.values(CompanySavedViewVisibilityEnumPrisma),
})

export enum NotificationEventName {
  CANDIDATE_HIRED_ON_MY_JOB = 'candidate_hired_on_my_job',
  NEW_CANDIDATE_MESSAGE_RECEIVED = 'new_candidate_message_received',
  OFFER_SENT_TO_CANDIDATE = 'offer_sent_to_candidate',
  CANDIDATE_SIGNED_OFFER = 'candidate_signed_offer',
  REFERRAL_SUBMITTED_FOR_MY_JOB = 'referral_submitted_for_my_job',
  SCORECARD_ASSIGNED_TO_ME = 'scorecard_assigned_to_me',
  INTERVIEW_SELF_SCHEDULED_WITH_ME = 'interview_self_scheduled_with_me',
  ASSIGNED_AS_INTERVIEWER = 'assigned_as_interviewer',
  INTERVIEW_TEAM_SCORECARD_SUBMITTED = 'interview_team_scorecard_submitted',
  INTERVIEW_DAY_MORNING_REMINDER = 'interview_day_morning_reminder',
  NEW_APPLICANT_TO_MY_JOB = 'new_applicant_to_my_job',
  JOB_AD_CAMPAIGN_EXPIRING_SOON = 'job_ad_campaign_expiring_soon',
  JOB_CLOSED_THAT_I_WAS_ASSIGNED_TO = 'job_closed_that_i_was_assigned_to',
  NEW_CANDIDATE_MATCH_FOR_MY_JOB = 'new_candidate_match_for_my_job',
  ASSIGNED_TO_HIRING_TEAM = 'assigned_to_hiring_team',
  ASSIGNED_AS_RECRUITER = 'assigned_as_recruiter',
  ASSIGNED_AS_HIRING_MANAGER = 'assigned_as_hiring_manager',
}

export const NotificationEventNameEnum = schemaBuilder.enumType('NotificationEventNameEnum', {
  values: Object.values(NotificationEventName),
})

export const DatePostedEnum = schemaBuilder.enumType('DatePostedEnum', {
  values: Object.values(DatePostedEnumPrisma) as [string, ...string[]],
})

export const RelocationTypePreferenceEnum = schemaBuilder.enumType('RelocationTypePreferenceEnum', {
  values: Object.values(RelocationTypePreferenceEnumPrisma) as [string, ...string[]],
})

export const TalentPoolVisibilityEnum = schemaBuilder.enumType('TalentPoolVisibilityEnum', {
  values: Object.values(TalentPoolVisibilityEnumPrisma),
})

export const TalentPoolTypeEnum = schemaBuilder.enumType('TalentPoolTypeEnum', {
  values: Object.values(TalentPoolTypeEnumPrisma),
})

export enum ExecutionSource {
  APPLICATION = 'APPLICATION',
  CHROME_EXTENSION = 'CHROME_EXTENSION',
}

export const ExecutionSourceEnum = schemaBuilder.enumType('ExecutionSourceEnum', {
  values: Object.values(ExecutionSource),
})

export const IconTypeEnum = schemaBuilder.enumType('IconTypeEnum', {
  values: Object.values(IconTypeEnumPrisma) as [string, ...string[]],
})
// Sequence related enums
export const SequenceCandidateStatusEnum = schemaBuilder.enumType('SequenceCandidateStatusEnum', {
  values: Object.values(SequenceCandidateStatusEnumPrisma),
})

export const SequenceStepSchedulerTypeEnum = schemaBuilder.enumType('SequenceStepSchedulerTypeEnum', {
  values: Object.values(SequenceStepSchedulerTypeEnumPrisma) as [string, ...string[]],
})

export const SequenceStepSendTimeTypeEnum = schemaBuilder.enumType('SequenceStepSendTimeTypeEnum', {
  values: Object.values(SequenceStepSendTimeTypeEnumPrisma) as [string, ...string[]],
})

export const SequenceStepSpreadStrategyEnum = schemaBuilder.enumType('SequenceStepSpreadStrategyEnum', {
  values: Object.values(SequenceStepSpreadStrategyEnumPrisma) as [string, ...string[]],
})

export const SequenceVisibilityEnum = schemaBuilder.enumType('SequenceVisibilityEnum', {
  values: Object.values(SequenceVisibilityEnumPrisma) as [string, ...string[]],
})

export const SequenceStatusEnum = schemaBuilder.enumType('SequenceStatusEnum', {
  values: Object.values(SequenceStatusEnumPrisma),
})

export const CustomCandidateFieldTypeEnum = schemaBuilder.enumType('CustomCandidateFieldTypeEnum', {
  values: Object.values(CustomCandidateFieldTypeEnumPrisma),
})
